<div class="container-fluid">
  <div class="row">
    <div class="card p-0">
      <div class="row m-0">
        <div class="col-sm-6 hidden-mobile left-image">
        </div>
        <div class="col-sm-6  form-div">
          <img src="../../../../../assets/Logo-new.svg" class="pt-3">
          <h6>Reset Password</h6>
          <form name="form" class="p-2" (submit)="loginForm.form.valid && onResetPassword(loginForm)"  [appMustMatch]="['password', 'confirmPassword']" 
            #loginForm="ngForm" novalidate>
            <div class="form-row">
              <div class="form-group col mb-0">
                <div class="input-group  ml-auto">
                  <input [type]="fieldTextType ? 'text' : 'password'" name="password" placeholder="New Password"
                    class="form-control" [(ngModel)]="model.password" #password="ngModel" maxlength="10"
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$"
                    [ngClass]="{ 'is-invalid': loginForm.submitted && password.invalid }" required>
                  <span class="input-group-append" (click)="toggleFieldTextType()">
                    <div class="input-group-text bg-transparent"> <i class="fa" [ngClass]="{
                                                        'fa-eye-slash': !fieldTextType,
                                                        'fa-eye': fieldTextType
                                                      }"></i>
                    </div>
                  </span>
                  <div *ngIf="loginForm.submitted && password.invalid" class="invalid-feedback">
                    <div *ngIf="password.errors.required">Password is required</div>
                    <div *ngIf="password.errors.minlength || password.errors.pattern">Password must be
                      at least Minimum six characters, at least one uppercase letter, one lowercase
                      letter,
                      one number and one special character: </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mt-3">
              <div class="form-group col mb-0">
                <div class="input-group  ml-auto">
                  <input [type]="fieldTextType1 ? 'text' : 'password'" name="confirmPassword"
                    placeholder="Confirm Password" class="form-control" [(ngModel)]="model.confirmPassword"
                    #confirmPassword="ngModel" maxlength="20"
                    [ngClass]="{ 'is-invalid': loginForm.submitted && confirmPassword.invalid }" required>
                  <span class="input-group-append" (click)="toggleFieldTextType1()">
                    <div class="input-group-text bg-transparent"> <i class="fa" [ngClass]="{
                                                        'fa-eye-slash': !fieldTextType1,
                                                        'fa-eye': fieldTextType1
                                                      }"></i>
                    </div>
                  </span>
                  <div *ngIf="loginForm.submitted && confirmPassword.invalid" class="invalid-feedback">
                    <div *ngIf="confirmPassword.errors.required">Password is required</div>
                    <div *ngIf="confirmPassword.errors.mustMatch">Passwords must match</div>

                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-3">
              <button class="btn  mr-1 mb-2"  type="submit">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>